export const StringHelper = {
  verticalBarSplit<T = any>(str: string = ""): T {
    if (!str || str.indexOf("|") === -1) return [] as T;
    return str.split("|") as T;
  },
  dashSplit(str: string = ""): string[] {
    if (!str) return [];
    return str.split("-");
  },
  parseJSON(str: string, defaultValue?: any) {
    if (!str) return defaultValue || "";
    return JSON.parse(str ?? `${defaultValue}`);
  },
  random(length: number = 10): string {
    const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let randomString = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters[randomIndex];
    }
    return randomString;
  },
  isImage(url: string) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  },

  getNameFromFileUrl(fileUrl: string = "") {
    const fileName = fileUrl.split("/").pop()!;
    return fileName.replace(/\([^)]*\)/g, "");
  },
  intToRoman(num: number): string {
    let result = "";
    let numCopy = num;
    const romanNumerals: { [key: number]: string } = {
      1: "I",
      4: "IV",
      5: "V",
      9: "IX",
      10: "X",
      40: "XL",
      50: "L",
      90: "XC",
      100: "C",
      400: "CD",
      500: "D",
      900: "CM",
      1000: "M",
    };
    const romanValues = Object.keys(romanNumerals)
      .map((key) => parseInt(key))
      .sort((a, b) => b - a);
    for (const value of romanValues) {
      const count = Math.floor(numCopy / value);
      numCopy %= value;
      result += romanNumerals[value].repeat(count);
    }

    return result;
  },
  intToChar(int: number, isUpperCase?: boolean) {
    const startInt = isUpperCase ? 65 : 97;
    return String.fromCharCode(startInt + int);
  },
  capitalize(text: string) {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  },

  escapeString(input: string): string {
    return input
      .replace(/&amp;/g, "&")
      .replace(/&agrave;/g, "à")
      .replace(/&Agrave;/g, "À")
      .replace(/&acirc;/g, "â")
      .replace(/&Acirc;/g, "Â")
      .replace(/&aacute;/g, "á")
      .replace(/&Aacute;/g, "Á")
      .replace(/&Igrave;/g, "Ì")
      .replace(/&igrave;/g, "ì")
      .replace(/&ocirc;/g, "ô")
      .replace(/&Ocirc;/g, "Ô")
      .replace(/&Ograve;/g, "Ò")
      .replace(/&ograve;/g, "ò")
      .replace(/&Oacute;/g, "Ó")
      .replace(/&oacute;/g, "ó")
      .replace(/&uacute;/g, "ú")
      .replace(/&Uacute;/g, "Ú")
      .replace(/&ugrave;/g, "ù")
      .replace(/&Ugrave;/g, "ù")
      .replace(/&ecirc;/g, "ê")
      .replace(/&Ecirc;/g, "Ê")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&nbsp;/g, " ")
      .replace(/&ndash;/g, "–");
    // Add more replacements as needed for other HTML entities
    // For example: .replace(/&lt;/g, "<").replace(/&gt;/g, ">")
    // Add more entities as needed
    // You can refer to a comprehensive list of HTML entities for more replacements
  },
};
